import { isEnumMember } from '@cutwise/utils';

import { DriveContainerId } from '@/drive/entities/DriveItemId';

export enum DriveSection {
  Public = 'public',
  PublicDiamonds = 'public-diamonds',
  PublicColorless = 'public-colorless',
  PublicFancy = 'public-fancy',
  PublicRough = 'public-rough',
  PublicLgd = 'public-ldg',
  PublicLgdColorless = 'public--lgd-colorless',
  PublicLgdFancy = 'public-lgd-fancy',
  PublicLgdRough = 'public-lgd-rough',
  PublicJewelry = 'public-jewelry',
  PublicGems = 'public-gems',
  DemoCollections = 'demo',

  PrivateRoot = 'private',
  PrivateDiamonds = 'private-diamonds',
  PrivateColorless = 'private-colorless',
  PrivateFancy = 'private-fancy',
  PrivateRough = 'private-rough',
  PrivateLgd = 'private-lgd',
  PrivateLgdColorless = 'private-lgd-colorless',
  PrivateLgdFancy = 'private-lgd-fancy',
  PrivateLgdRough = 'private-lgd-rough',
  PrivateJewelry = 'private-jewelry',
  PrivateGems = 'private-gems',
  PrivateProjects = 'projects',
  MyProjects = 'my-projects',
  SharedProjects = 'shared-projects',
  MultistageProjects = 'multistage-projects',
  Multistage = 'multistage',
  SharedMultistage = 'shared-multistage',

  Profile = 'profile',
  Billing = 'billing',
  ServicesGroup = 'services-group',
  Services = 'services',
  Tasks = 'tasks',
  WidgetBuilder = 'widget-builder',
  Admin = 'admin',
  Contacts = 'contacts',
  PinnedItems = 'pinned',
  DriveRoot = 'root',
  SharedWithMe = 'shared-with-me',
  Search = 'search',
  Spectrum = 'spectrum',
  Other = 'other',
}

export interface DriveParams {
  section: DriveSection;
  directoryId: DriveContainerId;
}

export function parseDriveParams({ section }: { section?: string } = {}): DriveParams {
  const directoryId = extractDirectoryId(section);

  if (directoryId !== null) {
    return { section: DriveSection.DriveRoot, directoryId: directoryId };
  }

  if (isEnumMember(section, DriveSection)) {
    return { section, directoryId: null };
  }

  return { section: DriveSection.DriveRoot, directoryId: null };
}

// a numeric first path segment addresses a folder under the drive root (e.g. /drive/123)
function extractDirectoryId(str: Nullable<string> | undefined): DriveContainerId {
  if (!str || !/^\d+$/.test(str)) {
    return null;
  }

  return parseInt(str, 10);
}
